import { TOKEN_LOGIN } from '@/shared/utils/constants'

/**
 * Значение для заголовка pageId в запросах к API.
 * WUI-3759: на маршруте /token-login в hash лежит длинный JWT — не отправляем его в бэкенд
 * (колонка WebLog.action_table ограничена).
 */
export const getPageIdForRequest = (): string => {
  if (typeof window === 'undefined') return ''
  return window.location.hash.includes('/token-login') ? TOKEN_LOGIN : window.location.hash
}
